import { render, staticRenderFns } from "./GalleryPublicFile.vue?vue&type=template&id=0c02d785&scoped=true"
import script from "./GalleryPublicFile.vue?vue&type=script&lang=js"
export * from "./GalleryPublicFile.vue?vue&type=script&lang=js"
import style0 from "./GalleryPublicFile.vue?vue&type=style&index=0&id=0c02d785&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c02d785",
  null
  
)

export default component.exports